module.exports = __webpack_public_path__ + "img/ecology-house.bb7784c1.jpg";